import { InputNumber } from "antd";
import styled from "styled-components";
import * as option from "utils/options";
import { ReactComponent as TIER } from "assets/icons/tier.svg";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import { DISCOUNT_TIER } from "api/interfaces/subscription.interface";
import { tierColor } from "styles/colors";
import { Text, ValidateWord } from "components/atoms/text/Text";
import Input from "components/atoms/input/Input";
import { PricingRequest } from "api/interfaces/accountInterface.interface";

interface Props {
  pricing: PricingRequest;
  onChangePricing: (
    name: string,
    value: DISCOUNT_TIER | number | undefined
  ) => void;
  validate?: boolean;
  validateMsg?: string;
}

export function AddOrgPricing(props: Props): JSX.Element {
  return (
    <TierWrapper>
      {option.discountTierOptions.map((tier) => {
        return (
          <TierItem
            tier={tier.value}
            isSelected={props.pricing.discountTier === tier.value}
            onClick={() => {
              props.onChangePricing("discountTier", tier.value);
            }}
            data-testid="account-add-add-tier-item-change-pricing"
          >
            <div className="tier-label">
              <TIER />
              {tier.label}
            </div>
          </TierItem>
        );
      })}
      <TierItem
        isSelected={props.pricing.discountTier === DISCOUNT_TIER.CUSTOM}
        tier={DISCOUNT_TIER.CUSTOM}
        onClick={() => {
          props.onChangePricing("discountTier", DISCOUNT_TIER.CUSTOM);
        }}
        data-testid="account-add-add-tier-item-change-pricing-2"
      >
        <div className="tier-label">
          <TIER />
          CUSTOM
        </div>
        <div className="custom-fields">
          <div className="field-row">
            <Text bold className="field-label">
              Discount
            </Text>
            <div className="field-input">
              <InputNumber
                value={props.pricing.discount}
                onChange={(value) =>
                  props.onChangePricing("discount", value as number)
                }
                onKeyDown={(e) => {
                  // Control/navigation keys (Backspace, Arrow*, Tab, Enter, Escape, Home/End, …)
                  // all report a key name longer than 1 character - let them through untouched.
                  if (e.ctrlKey || e.metaKey || e.altKey || e.key.length > 1) {
                    return;
                  }
                  if (e.key === ".") {
                    if (e.currentTarget.value.includes(".")) {
                      e.preventDefault();
                    }
                    return;
                  }
                  if (!/^[0-9]$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData("text");
                  if (!/^[0-9]*\.?[0-9]*$/.test(pasted)) {
                    e.preventDefault();
                  }
                }}
                status={props.validate ? "error" : undefined}
                min={0}
                max={100}
              />
              <Text>%</Text>
            </div>
          </div>
          {/* <div className="field-row">
            <Text bold className="field-label">
              Credit Limit
            </Text>
            <Input
              className="field-input"
              value={props.pricing.creditLimit ?? ""}
              placeholder="Set credit limit (i.e. $5000)"
              // Credit limit applies regardless of the selected discount tier -
              // stop the click from bubbling to the CUSTOM row and switching the tier as a side effect.
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                if (e.target.value === "") {
                  props.onChangePricing("creditLimit", undefined);
                  return;
                }
                const parsed = Number(e.target.value);
                if (Number.isNaN(parsed)) {
                  return;
                }
                props.onChangePricing("creditLimit", parsed);
              }}
              data-testid="account-add-add-input-change-pricing"
            />
          </div> */}
        </div>
      </TierItem>

      {props.validate && props.validateMsg !== "" && (
        <ValidateWord data-testid="account-add-validate">
          {props.validateMsg}
        </ValidateWord>
      )}
    </TierWrapper>
  );
}

const TierWrapper = styled.ul`
  width: 90%;
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 20px;
  padding: 50px 0;
`;

const TierItem = styled.li<{ tier?: DISCOUNT_TIER; isSelected: boolean }>`
  ${FLEX.FlexBetweenCenter};
  width: 100%;
  padding: 0 40px;
  min-height: 80px;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  border-radius: 3px;

  cursor: pointer;

  > div {
    ${FLEX.FlexStartCenter};
    flex: 1;
    gap: 8px;
  }
  .custom-fields {
    flex: 1.5;

    padding: 10px 0;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;

    .field-row {
      width: 100%;
      ${FLEX.FlexEndCenter};
      gap: 12px;
    }
    .field-label {
      flex-shrink: 0;
      min-width: 76px;
      font-size: ${calcRem(14)};
    }
    .field-input {
      ${FLEX.FlexStartCenter};
      /* flex: 1; */
      gap: 8px;
    }
  }
  .tier-label {
    font-weight: 500;
    font-size: ${calcRem(24)};

    ${({ tier, theme }) =>
      tier &&
      `
    color: ${tierColor(tier, theme)};
  `}
  }

  ${({ isSelected, theme }) =>
    isSelected &&
    `
    outline: 3px solid ${theme.COLORS.SELECTED}
  `}
`;
